// import React from 'react'
import { FragmentProps } from '../../../interfaces/Publication'
import parse from 'html-react-parser'
// import Figure from './Figure'
import { usePublication } from '../../../hooks/usePublication'


const IMGTXT = ({fragment}: FragmentProps) => {

    const {path} = usePublication()

    return (
        <div className="grid grid-2col">
            <div className="grid__cell">
                {/* <Figure path={fragment.text}></Figure> */}
                <figure className="image">
                    <a
                    href= {fragment.urlObj}
                    data-fancybox=""
                    data-caption= {fragment.title}
                    ><img
                        className="image__image"
                        src={`${path}images/${fragment.img}`}
                        alt=""
                    /></a>
                    <figcaption className="image__caption">
                    {fragment.title}
                    </figcaption>
                </figure>
            </div>
            <div className="grid__cell">
                {fragment.text?parse(fragment.text):null}
            </div>
        </div>
    )
}

export default IMGTXT
